export const TOPIC_MODEL_CURATION_SRV_ID = "tmc";

export function isTopicModelCurationServiceTypeName(name: string | undefined | null): boolean {
  return (name || "").toLowerCase() === "topic model curation";
}
